import { React, useState } from "react";
import { Table, Form, Dropdown, Button, Row, Col } from "react-bootstrap";
import classes from "./index.module.scss";
import cardimg from "Images/userImg.png";
import AddNewCard from "../../../Components/AddNewCard";
import UpdateCard from "../updateCard/UpdateCard";

const AllTabData = (props) => {
  const { content } = props;

  const [modalShow, setModalShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  // edit state
  const [show, setShow] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  const selectedFunction = (item) => {
    console.log(item);
    if (show == true) {
      setShow(false);
      setSelectedData({});
    } else {
      setShow(true);
      setSelectedData(item);
    }
  };

  // convert date format to month / day / year
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [month, day, year].join("/");
  }

  const handleSearch = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  return (
    <>
      <div className={classes.tableFilter}>
        <Form>
          <Row>
            <Col md={8}>
              <div className={"d-md-flex"}>
                <Button variant="filter">
                  <i className={"fal fa-filter"}></i>
                  Filter
                </Button>
                <Form.Group className={classes.searchForm}>
                  <Form.Control
                    type="search"
                    placeholder="Search Users by Name, Email or Date"
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </Form.Group>
              </div>
            </Col>
            <Col md={4} className={"d-md-flex justify-content-end"}>
              <Button onClick={() => setModalShow(true)}>Add New</Button>
              <AddNewCard
                subAdminAllData={props.subAdminAllData}
                show={modalShow}
                onHide={() => setModalShow(false)}
              />
            </Col>
          </Row>
        </Form>
      </div>
      <Table>
        <thead>
          <tr>
            <th>
              <Form.Check type="checkbox" />
            </th>
            <th>Name</th>
            <th>date posted</th>
            <th>source</th>
            <th>status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {content
            ?.filter((row) => {
              let rowSearchTerm = searchTerm.toString().toLowerCase().trim();
              let title = row.cardTitle.toString().toLowerCase();
              let description = row.description.toString().toLowerCase();
              return (
                !rowSearchTerm.length ||
                title.includes(rowSearchTerm) ||
                description.includes(rowSearchTerm)
              );
            })
            .map((content) => (
              <tr>
                <td>
                  <Form.Check type="checkbox" />
                </td>
                <td>
                  <div className={"d-flex"}>
                    <div className={classes.userImg}>
                      <img
                        src={
                          "https://api.gowild.appscorridor.com" +
                          content.picture
                        }
                        width="100%"
                        alt={content.cardTitle}
                      />
                    </div>
                    <div className={classes.description}>
                      <h4 className={"font-16 mb-0"}>{content.cardTitle}</h4>
                      <div className={"text-muted"}>{content.description}</div>
                    </div>
                  </div>
                </td>
                <td>{formatDate(content.status?.updatedDate)}</td>
                <td>{content.cardSponsor}</td>
                <td>
                  {content.status.isActive ? (
                    <span class="text-success">Active</span>
                  ) : (
                    <span class="text-danger">InActive</span>
                  )}
                </td>
                <td>
                  <Dropdown>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      <i className={"far fa-ellipsis-v fa-fw"}></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        href="#/"
                        onClick={() => selectedFunction(content)}
                      >
                        <i className={"far fa-pen bg-success text-white"}></i>
                        Update Card
                      </Dropdown.Item>

                      <Dropdown.Item
                        href="#/"
                        onClick={() => props.deleteSubAdmin(content.id)}
                      >
                        <i className={"fal fa-trash bg-danger text-white"}></i>
                        Delete
                      </Dropdown.Item>
                      <Dropdown.Item href="#/">
                        <i className={"fal fa-ban bg-dark text-white"}></i>
                        View Participants
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>

      <UpdateCard
        subAdminAllData={props.subAdminAllData}
        show={show}
        selectedData={selectedData}
        onHide={() => setShow(false)}
      />
    </>
  );
};

export default AllTabData;
